module.exports = __webpack_public_path__ + "img/th.547bf897.png";